<template>
    <div>
        <el-table v-loading="students.length === 0" :data="students" height="740">
            <el-table-column
                min-width="100"
                sortable
                label="Number"
                property="number"
            ></el-table-column>
            <el-table-column
                min-width="130"
                sortable
                label="Name"
                property="name"
            ></el-table-column>
            <el-table-column
                min-width="100"
                label="PIN"
                property="pin"
            ></el-table-column>
            <el-table-column
                min-width="150"
                label="Actions"
                class-name="text-right"
            >
                <div slot-scope="{row, $index  }" class="text-right table-actions">
                    <el-tooltip
                        content="View the recent call history of a student"
                        effect="light"
                        :open-delay="300"
                        placement="top"

                    >
                        <router-link :to="'/school/classroom/' + row.classroom_id + '/student/' + row.id + '/history'">
                            <base-button type="info" size="sm" class="right">
                                History
                            </base-button>
                        </router-link>
                    </el-tooltip>
                    <el-tooltip
                        content="Change name of the student"
                        effect="light"
                        :open-delay="300"
                        placement="top"
                    >
                        <base-button type="primary" size="sm" class="right" @click="updateStudentName(row)">
                            Update
                        </base-button>
                    </el-tooltip>
                </div>
            </el-table-column>
        </el-table>
        <change-student-name-modal v-if="showUpdateModal" :student="selectedStudent" @save="handleUpdateName"
                                   @close="showUpdateModal =  false"/>
    </div>

</template>
<script>
    import ChangeStudentNameModal from "./ChangeStudentNameModal";
    import axios from "axios";

    export default {
        name: 'student-table',
        components: {ChangeStudentNameModal},
        props: ['students'],
        data() {
            return {
                showUpdateModal: false,
                selectedStudent: null
            }
        },
        methods: {
            updateStudentName(row) {
                this.selectedStudent = row;
                this.showUpdateModal = true;
            },
            handleUpdateName({new_name}) {
                axios.post(this.baseAPIURL + 'student/' + this.selectedStudent.id, {
                    'name': new_name,
                    '_method': 'put',
                }).finally(() => {
                    this.$emit('updated');
                    this.showUpdateModal = false;
                });

            }
        }
    }
</script>
